import type { SpotUsage } from '../../../api/my-parking-spots';

export function getUsageForWindow(
  usages: SpotUsage[],
  windowId: string,
): SpotUsage | undefined {
  return usages.find(
    (usage) =>
      usage.availabilityWindowId &&
      String(usage.availabilityWindowId) === String(windowId) &&
      (usage.status === 'PENDING' || usage.status === 'ACTIVE'),
  );
}

export function getPendingUsageForPeriod(
  usages: SpotUsage[],
  spotId: string,
  windowStartAt: string,
  windowEndAt: string,
): SpotUsage | undefined {
  const windowStart = new Date(windowStartAt);
  const windowEnd = new Date(windowEndAt);

  return usages.find((usage) => {
    if (usage.status !== 'PENDING') return false;
    if (!usage.spotId || String(usage.spotId) !== String(spotId)) return false;

    const usageStart = new Date(usage.startAt);
    const usageEnd = new Date(usage.endAt);
    return windowStart < usageEnd && windowEnd > usageStart;
  });
}

export function canRequestUsage(
  existingUsage: SpotUsage | undefined,
  isMine: boolean,
): boolean {
  if (isMine) return false;
  if (!existingUsage) return true;
  return ['CANCELLED', 'REJECTED', 'FINISHED'].includes(existingUsage.status);
}
